var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Application_Icon",
    "data-name": "Application Icon",
    transform: "translate(4072 -4498)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(-4072 4530) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "description_24dp_FILL1_wght400_GRAD0_opsz24",
    d: "M166-860.8h7.2a1.161,1.161,0,0,0,.855-.345A1.161,1.161,0,0,0,174.4-862a1.161,1.161,0,0,0-.345-.855,1.161,1.161,0,0,0-.855-.345H166a1.161,1.161,0,0,0-.855.345,1.161,1.161,0,0,0-.345.855,1.161,1.161,0,0,0,.345.855A1.161,1.161,0,0,0,166-860.8Zm0-4.8h7.2a1.161,1.161,0,0,0,.855-.345,1.161,1.161,0,0,0,.345-.855,1.161,1.161,0,0,0-.345-.855A1.161,1.161,0,0,0,173.2-868H166a1.161,1.161,0,0,0-.855.345,1.161,1.161,0,0,0-.345.855,1.161,1.161,0,0,0,.345.855A1.161,1.161,0,0,0,166-865.6Zm-3.6,9.6a2.311,2.311,0,0,1-1.695-.705,2.311,2.311,0,0,1-.705-1.7v-19.2a2.311,2.311,0,0,1,.705-1.7A2.311,2.311,0,0,1,162.4-880h8.61a2.369,2.369,0,0,1,.915.18,2.331,2.331,0,0,1,.765.51l5.82,5.82a2.331,2.331,0,0,1,.51.765,2.369,2.369,0,0,1,.18.915v13.41a2.311,2.311,0,0,1-.705,1.7A2.311,2.311,0,0,1,176.8-856Zm8.4-16.8a1.161,1.161,0,0,0,.345.855,1.161,1.161,0,0,0,.855.345h4.8l-6-6Z",
    transform: "translate(-4226 5382)",
    fill: "#0469ac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.655e492f0405457591a51a806a0d4262.svg";
export { ForwardRef as ReactComponent };